import { useCallback } from 'react';

export function useInputHandler(
  regex: RegExp,
  setter: React.Dispatch<React.SetStateAction<string>>,
  setReviewMode: (v: boolean) => void
) {
  const isControlKey = (e: KeyboardEvent | any) => {
    if (e.ctrlKey || e.metaKey || e.altKey) return true;
    return e.key.length !== 1;
  };

  const onKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      if (isControlKey(e)) return;
      if (!regex.test(e.key)) {
        e.preventDefault();
      }
    },
    [regex]
  );

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const value = e.target.value;
      if (!regex.test(value)) {
        setter('');
        return;
      }
      setter(value);
    },
    [regex, setter, setReviewMode]
  );

  const onPaste = useCallback(
    (e: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      const pastedText = e.clipboardData.getData('text');
      if (!regex.test(pastedText)) {
        e.preventDefault();
      }
    },
    [regex]
  );

  const onBlur = useCallback(
    (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      let value = e.target.value;
      value = value.trim();
      if (!regex.test(value)) {
        setter('');
        return;
      }
      setter(value);
    },
    [regex, setter]
  );

  return {
    onKeyDown,
    onChange,
    onPaste,
    onBlur,
  };
}
